import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NewsComponent from "./newscomponent";

const News = () => {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch("/api/get_latest_news.php"); // без user_id
        const data = await response.json();
        if (data.success) setNews(data.news);
      } catch (error) {
        console.error("Ошибка при загрузке новостей:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <section className="p-5 mb-10 flex justify-start items-start flex-col w-full">
      <h1 className="text-4xl max-lg:text-2xl  text-start py-2 ml-5 mb-5 uppercase font-bold text-white">
        {t("news")}
      </h1>

      <section className="w-full flex justify-start items-end flex-col gap-3">
        <section className="w-full flex justify-start items-center gap-6 flex-wrap">
          {loading ? (
            <p className="text-white">{t("loading")}</p>
          ) : news.length === 0 ? (
            <p className="text-white">{t("nonews")}</p>
          ) : (
            news.map((item) => (
              <NewsComponent
                key={item.id}
                id={item.id}
                img={`/api/uploads/${item.image}`}
                companyname={item.companyName}
                companylogo={item.companyLogo}
                title={item.title}
                description={item.description}
                date={new Date(item.created_at).toLocaleDateString()}
              />
            ))
          )}
        </section>

        <Link
          className="mr-6 text-white relative before:top-full before:w-0 before:transition-all
          before:duration-200 before:h-[2px] before:absolute before:bg-white hover:before:w-full mt-4"
          to="/Global_News"
        >
          {t("seemore")}
        </Link>
      </section>
    </section>
  );
};

export default News;
